import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Moderation } from '../classes/moderation';
import { DateCalculationService } from './date-calculation.service';
import { TokenService } from './token.service';
import {catchError} from 'rxjs/operators'
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ModerationService {

  constructor(private http: HttpClient, private dateService: DateCalculationService, private tokenService : TokenService) { }

  /**
   * Fonction test appel serveur
   */
  testWebService() {
    let httpHeaders = this.tokenService.loadToken();
    return this.http.post('/api/traitement/test',{}, {headers: httpHeaders});
  }


  /***
   * Fonction qui récupère les modérations libres
   */
  getCurrentModerationLibres(matricule: number) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/a-moderer?matricule=" + matricule; 
    return this.http.get(request, {headers : httpHeaders});
  }

  /***
   * Fonction qui récupère les modérations libres
   */
  getCurrentModerationLibresDuplicated(matricule: number) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/a-moderer?matricule=" + matricule;
    return this.http.get(request, {headers : httpHeaders});
  }


  getPtlEnAttenteCq() {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/attente-cq";
    return this.http.get(request, {headers : httpHeaders});
  }

  /**
   * Fonction appellée lorsqu'une PTL a été affectée
   */
  changerEtat(options: Object){
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/changer-etat/" + JSON.stringify(options);
    return this.http.post(request,  {} ,{headers: httpHeaders});
  }



  annulerTraitement(options : Object) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/annuler-traitement?options=" + JSON.stringify(options);
    return this.http.post(request,  {} ,{headers: httpHeaders});
  }

  /**
   * Regarde si l'operateur a un ptl en cours de traitement
   */
  checkIfHasEnCours(idResponsable : number) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/en-cours-by-responsable/" + idResponsable;
    return this.http.get(request, {headers : httpHeaders});
  }


  /**
   * Récupère les détails d'un Ptl
   * @param numPointAccueil 
   */
  getDetailsPtl(numPointAccueil : number) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/" + numPointAccueil;
    return this.http.get(request, {headers : httpHeaders});
  }


  getNextTraitement(type : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/next-traitement?for=" + type;
    return this.http.get(request, {headers : httpHeaders});
  }

  getBrouillon() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/brouillons";
    return this.http.get(request, {headers : httpHeaders});
  }

  sendExcel(options: Object) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/service/reception";
    var jsonObject = options;
    console.log(options);
    return this.http.post(request, jsonObject, {headers : httpHeaders });
  }

  getFichesEnAttenteValidation() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/en-attente-validation";
    return this.http.get(request, {headers: httpHeaders});
  }


  /**
   * Fonction appellée lorsqu'une PTL a été affectée
   */
  affecterFiche(idResponsable:number,idModeration:number){
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/affecter?moderation=" + idModeration + "&responsable=" + idResponsable;
    return this.http.post(request,  {} ,{headers: httpHeaders});
  }


  //fin du fichier
}
